import useSWR, { SWRResponse } from "swr";

import { useAuthErrorHandler } from "../common/hooks";
import { ResponseWithPagination } from "../types/common";

import request, { ApiError } from "./common";

const activityLogApi = {
    export: (): Promise<ActivityLogResponse[]> => {
        return request<ActivityLogResponse[], null>(
            "/activity-log/export",
            "GET",
        );
    },
};

export const useActivityLogsList = (
    actionTakerIds?: number[],
    activityType?: string,
    dateFrom?: Date | null,
    dateTo?: Date | null,
    page?: number,
    size?: number,
): SWRResponse<ResponseWithPagination<ActivityLogResponse[]>, ApiError> => {
    const params = [];
    const onError = useAuthErrorHandler();

    if (actionTakerIds && actionTakerIds.length)
        params.push(`ids=${actionTakerIds}`);
    if (activityType) params.push(`activityType=${activityType}`);
    if (dateFrom) params.push(`dateFrom=${dateFrom.getTime()}`);
    if (dateTo) params.push(`dateTo=${dateTo.getTime() + 86399999}`);
    if (typeof page == "number") params.push(`page=${page}`);
    if (typeof size == "number") params.push(`size=${size}`);

    return useSWR<ResponseWithPagination<ActivityLogResponse[]>, ApiError>(
        `/activity-log?${params.join("&")}`,
        request,
        {
            onError,
        },
    );
};

export type ActivityLogResponse = {
    id?: number;
    activityType: string; // Create User, Updated User, Deleted User
    changedUserInfo: string; // "firstName lastName (email)"
    updateDetails?: UpdateDetails[];
    actionedUser: ActionedUser;
    activityTimestamp: string;
};

export type UpdateDetails = {
    field: string;
    oldValue: string;
    newValue: string;
};

type ActionedUser = {
    fullName: string;
    email: string;
};

export default activityLogApi;
